/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
// import { Link } from "@quintype/components";
import "./popup.m.css";

/*
Popup/Modal element with cross icon at top and children prop for reusability
*/
export const Popup = ({ children, showModal, setShowModal, hideCloseIcon }) => {
  // const [showModal, setShowModal] = React.useState(true)
  const { fetchSubscription, member } = useSelector(state => state);

  const pushToDataLayer = (event, action) => {
    const obj = {
      event: event,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    if (action) {
      obj.paywall_user_action = action;
    }

    window.dataLayer.push(obj);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--secondary-color)",
      borderRadius: "10px",
      border: "none",
      maxWidth: "400px",
      padding: "0px",
      boxShadow: "4px 3px 10px 0 rgb(0 0 0 / 62%)"
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.35)",
      zIndex: "2"
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={() => {
        pushToDataLayer("popup_paywall_user_action", "close");
        setShowModal(false);
      }}
      style={customStyles}
      shouldCloseOnOverlayClick={true}
    >
      <div styleName="content-wrapper">
        {!hideCloseIcon && (
          <i
            className="material-icons-outlined"
            onClick={() => {
              pushToDataLayer("popup_paywall_user_action", "close");
              setShowModal(false);
            }}
          >
            close
          </i>
        )}
        {children}
      </div>
    </Modal>
  );
};
